// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file plataforma_ventas_pipeline.proto (package sextante.plataforma.ventas.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plataforma_ventas_pipeline.proto.
 */
export const file_plataforma_ventas_pipeline: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Filtros opcionales del listado.
 *
 * @generated from message sextante.plataforma.ventas.v1.ListOportunidadesRequest
 */
export type ListOportunidadesRequest = Message<"sextante.plataforma.ventas.v1.ListOportunidadesRequest"> & {
  /**
   * Nombre o NIT del cliente (contiene, sin distinguir mayusculas).
   *
   * @generated from field: optional string q = 1;
   */
  q?: string | undefined;

  /**
   * Etapa: new, contacted, demo, proposal, closed_won o closed_lost.
   *
   * @generated from field: optional string stage = 2;
   */
  stage?: string | undefined;

  /**
   * Origen: web, whatsapp, app, campo o manual.
   *
   * @generated from field: optional string source = 3;
   */
  source?: string | undefined;

  /**
   * Usuario comercial responsable.
   *
   * @generated from field: optional string comercial_id = 4;
   */
  comercialId?: string | undefined;

  /**
   * @generated from field: optional string cliente_id = 5;
   */
  clienteId?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.ListOportunidadesRequest.
 * Use `create(ListOportunidadesRequestSchema)` to create a new message.
 */
export const ListOportunidadesRequestSchema: GenMessage<ListOportunidadesRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 0);

/**
 * Oportunidades que cumplen los filtros.
 *
 * @generated from message sextante.plataforma.ventas.v1.ListOportunidadesResponse
 */
export type ListOportunidadesResponse = Message<"sextante.plataforma.ventas.v1.ListOportunidadesResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.ventas.v1.OportunidadPipelineItem items = 1;
   */
  items: OportunidadPipelineItem[];
};

/**
 * Describes the message sextante.plataforma.ventas.v1.ListOportunidadesResponse.
 * Use `create(ListOportunidadesResponseSchema)` to create a new message.
 */
export const ListOportunidadesResponseSchema: GenMessage<ListOportunidadesResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 1);

/**
 * Oportunidad de venta del pipeline, con sus eventos.
 *
 * @generated from message sextante.plataforma.ventas.v1.OportunidadPipelineItem
 */
export type OportunidadPipelineItem = Message<"sextante.plataforma.ventas.v1.OportunidadPipelineItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;

  /**
   * @generated from field: string cliente_nombre = 3;
   */
  clienteNombre: string;

  /**
   * @generated from field: optional string cliente_nit = 4;
   */
  clienteNit?: string | undefined;

  /**
   * Origen: web, whatsapp, app, campo o manual.
   *
   * @generated from field: string source = 5;
   */
  source: string;

  /**
   * Etapa: new, contacted, demo, proposal, closed_won o closed_lost.
   *
   * @generated from field: string stage = 6;
   */
  stage: string;

  /**
   * @generated from field: optional string comercial_id = 7;
   */
  comercialId?: string | undefined;

  /**
   * @generated from field: optional string comercial_nombre = 8;
   */
  comercialNombre?: string | undefined;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 prox_contacto = 9;
   */
  proxContacto?: bigint | undefined;

  /**
   * Notas libres del comercial.
   *
   * @generated from field: string notas = 10;
   */
  notas: string;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 activated_at = 11;
   */
  activatedAt?: bigint | undefined;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 renovation_at = 12;
   */
  renovationAt?: bigint | undefined;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 demo_fin = 13;
   */
  demoFin?: bigint | undefined;

  /**
   * Valor de la venta, en pesos.
   *
   * @generated from field: optional int64 valor_cierre = 14;
   */
  valorCierre?: bigint | undefined;

  /**
   * Ausente = sin productos cargados.
   *
   * @generated from field: optional sextante.plataforma.ventas.v1.ProductosPipelineItem productos = 15;
   */
  productos?: ProductosPipelineItem | undefined;

  /**
   * Del mas reciente al mas antiguo.
   *
   * @generated from field: repeated sextante.plataforma.ventas.v1.EventoPipelineItem eventos = 16;
   */
  eventos: EventoPipelineItem[];

  /**
   * Unix ms
   *
   * @generated from field: int64 created_at = 17;
   */
  createdAt: bigint;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.OportunidadPipelineItem.
 * Use `create(OportunidadPipelineItemSchema)` to create a new message.
 */
export const OportunidadPipelineItemSchema: GenMessage<OportunidadPipelineItem> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 2);

/**
 * Productos cotizados en la oportunidad.
 *
 * @generated from message sextante.plataforma.ventas.v1.ProductosPipelineItem
 */
export type ProductosPipelineItem = Message<"sextante.plataforma.ventas.v1.ProductosPipelineItem"> & {
  /**
   * Incluye la licencia de DATA AG.
   *
   * @generated from field: bool dataag = 1;
   */
  dataag: boolean;

  /**
   * Unidades de GPS RASTRO.
   *
   * @generated from field: int32 rastro = 2;
   */
  rastro: number;

  /**
   * Unidades de bascula.
   *
   * @generated from field: int32 bascula = 3;
   */
  bascula: number;

  /**
   * Incluye VISTA, el servicio de fotogrametria.
   *
   * @generated from field: bool vista = 4;
   */
  vista: boolean;

  /**
   * Servicio PROTEC de aspersion.
   *
   * @generated from field: sextante.plataforma.ventas.v1.ProtecPipelineItem protec = 5;
   */
  protec?: ProtecPipelineItem | undefined;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.ProductosPipelineItem.
 * Use `create(ProductosPipelineItemSchema)` to create a new message.
 */
export const ProductosPipelineItemSchema: GenMessage<ProductosPipelineItem> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 3);

/**
 * Cotizacion de PROTEC.
 *
 * @generated from message sextante.plataforma.ventas.v1.ProtecPipelineItem
 */
export type ProtecPipelineItem = Message<"sextante.plataforma.ventas.v1.ProtecPipelineItem"> & {
  /**
   * @generated from field: bool activo = 1;
   */
  activo: boolean;

  /**
   * Categoria de PROTEC elegida.
   *
   * @generated from field: string cat = 2;
   */
  cat: string;

  /**
   * Hectareas a cotizar.
   *
   * @generated from field: double ha = 3;
   */
  ha: number;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.ProtecPipelineItem.
 * Use `create(ProtecPipelineItemSchema)` to create a new message.
 */
export const ProtecPipelineItemSchema: GenMessage<ProtecPipelineItem> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 4);

/**
 * Evento de la historia de una oportunidad.
 *
 * @generated from message sextante.plataforma.ventas.v1.EventoPipelineItem
 */
export type EventoPipelineItem = Message<"sextante.plataforma.ventas.v1.EventoPipelineItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Tipo de evento, como stage_change, note, llamada, visita, demo o cierre.
   *
   * @generated from field: string tipo = 2;
   */
  tipo: string;

  /**
   * JSON; su forma depende del tipo.
   *
   * @generated from field: string metadata_json = 3;
   */
  metadataJson: string;

  /**
   * Unix ms
   *
   * @generated from field: int64 fecha = 4;
   */
  fecha: bigint;

  /**
   * @generated from field: optional string usuario_nombre = 5;
   */
  usuarioNombre?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.EventoPipelineItem.
 * Use `create(EventoPipelineItemSchema)` to create a new message.
 */
export const EventoPipelineItemSchema: GenMessage<EventoPipelineItem> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 5);

/**
 * Oportunidad a crear o editar.
 *
 * @generated from message sextante.plataforma.ventas.v1.GuardarOportunidadRequest
 */
export type GuardarOportunidadRequest = Message<"sextante.plataforma.ventas.v1.GuardarOportunidadRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;

  /**
   * @generated from field: string source = 3;
   */
  source: string;

  /**
   * Solo aplica al editar; ausente conserva la etapa.
   *
   * @generated from field: optional string stage = 4;
   */
  stage?: string | undefined;

  /**
   * @generated from field: optional string comercial_id = 5;
   */
  comercialId?: string | undefined;

  /**
   * Ausente = sin proximo contacto.
   *
   * Unix ms
   *
   * @generated from field: optional int64 prox_contacto = 6;
   */
  proxContacto?: bigint | undefined;

  /**
   * Ausente conserva las notas.
   *
   * @generated from field: optional string notas = 7;
   */
  notas?: string | undefined;

  /**
   * Ausente conserva el valor.
   *
   * @generated from field: optional int64 valor_cierre = 8;
   */
  valorCierre?: bigint | undefined;

  /**
   * Ausente = sin productos.
   *
   * @generated from field: optional sextante.plataforma.ventas.v1.ProductosPipelineItem productos = 9;
   */
  productos?: ProductosPipelineItem | undefined;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.GuardarOportunidadRequest.
 * Use `create(GuardarOportunidadRequestSchema)` to create a new message.
 */
export const GuardarOportunidadRequestSchema: GenMessage<GuardarOportunidadRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 6);

/**
 * Etapa nueva de una oportunidad.
 *
 * @generated from message sextante.plataforma.ventas.v1.CambiarEtapaRequest
 */
export type CambiarEtapaRequest = Message<"sextante.plataforma.ventas.v1.CambiarEtapaRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string stage = 2;
   */
  stage: string;

  /**
   * Si viene, tambien se registra como evento note.
   *
   * @generated from field: optional string nota = 3;
   */
  nota?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.CambiarEtapaRequest.
 * Use `create(CambiarEtapaRequestSchema)` to create a new message.
 */
export const CambiarEtapaRequestSchema: GenMessage<CambiarEtapaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 7);

/**
 * Evento a registrar en una oportunidad.
 *
 * @generated from message sextante.plataforma.ventas.v1.AgregarEventoRequest
 */
export type AgregarEventoRequest = Message<"sextante.plataforma.ventas.v1.AgregarEventoRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string tipo = 2;
   */
  tipo: string;

  /**
   * JSON; ausente = "{}".
   *
   * @generated from field: optional string metadata_json = 3;
   */
  metadataJson?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.AgregarEventoRequest.
 * Use `create(AgregarEventoRequestSchema)` to create a new message.
 */
export const AgregarEventoRequestSchema: GenMessage<AgregarEventoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 8);

/**
 * Oportunidad sobre la que se actua.
 *
 * @generated from message sextante.plataforma.ventas.v1.OportunidadIdRequest
 */
export type OportunidadIdRequest = Message<"sextante.plataforma.ventas.v1.OportunidadIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.OportunidadIdRequest.
 * Use `create(OportunidadIdRequestSchema)` to create a new message.
 */
export const OportunidadIdRequestSchema: GenMessage<OportunidadIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 9);

/**
 * Dias a sumar a la demo.
 *
 * @generated from message sextante.plataforma.ventas.v1.ExtenderDemoRequest
 */
export type ExtenderDemoRequest = Message<"sextante.plataforma.ventas.v1.ExtenderDemoRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 dias = 2;
   */
  dias: number;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.ExtenderDemoRequest.
 * Use `create(ExtenderDemoRequestSchema)` to create a new message.
 */
export const ExtenderDemoRequestSchema: GenMessage<ExtenderDemoRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 10);

/**
 * Fecha de renovacion nueva.
 *
 * @generated from message sextante.plataforma.ventas.v1.RenovarOportunidadRequest
 */
export type RenovarOportunidadRequest = Message<"sextante.plataforma.ventas.v1.RenovarOportunidadRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Unix ms
   *
   * @generated from field: int64 renovation_at = 2;
   */
  renovationAt: bigint;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.RenovarOportunidadRequest.
 * Use `create(RenovarOportunidadRequestSchema)` to create a new message.
 */
export const RenovarOportunidadRequestSchema: GenMessage<RenovarOportunidadRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 11);

/**
 * Sin datos: que el rpc no falle ya indica que se hizo.
 *
 * @generated from message sextante.plataforma.ventas.v1.PipelineAccionResponse
 */
export type PipelineAccionResponse = Message<"sextante.plataforma.ventas.v1.PipelineAccionResponse"> & {
};

/**
 * Describes the message sextante.plataforma.ventas.v1.PipelineAccionResponse.
 * Use `create(PipelineAccionResponseSchema)` to create a new message.
 */
export const PipelineAccionResponseSchema: GenMessage<PipelineAccionResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 12);

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.ventas.v1.PipelineStatsRequest
 */
export type PipelineStatsRequest = Message<"sextante.plataforma.ventas.v1.PipelineStatsRequest"> & {
};

/**
 * Describes the message sextante.plataforma.ventas.v1.PipelineStatsRequest.
 * Use `create(PipelineStatsRequestSchema)` to create a new message.
 */
export const PipelineStatsRequestSchema: GenMessage<PipelineStatsRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 13);

/**
 * Indicadores del tablero del pipeline.
 *
 * @generated from message sextante.plataforma.ventas.v1.PipelineStatsResponse
 */
export type PipelineStatsResponse = Message<"sextante.plataforma.ventas.v1.PipelineStatsResponse"> & {
  /**
   * @generated from field: int32 oportunidades_activas = 1;
   */
  oportunidadesActivas: number;

  /**
   * @generated from field: int32 demos_agendadas = 2;
   */
  demosAgendadas: number;

  /**
   * @generated from field: int32 cerradas_ganadas = 3;
   */
  cerradasGanadas: number;

  /**
   * @generated from field: int32 cerradas_perdidas = 4;
   */
  cerradasPerdidas: number;

  /**
   * @generated from field: double tasa_conversion = 5;
   */
  tasaConversion: number;

  /**
   * @generated from field: repeated sextante.plataforma.ventas.v1.EmbudoPipelineItem embudo = 6;
   */
  embudo: EmbudoPipelineItem[];

  /**
   * @generated from field: repeated sextante.plataforma.ventas.v1.FuentePipelineItem por_fuente = 7;
   */
  porFuente: FuentePipelineItem[];

  /**
   * @generated from field: repeated sextante.plataforma.ventas.v1.ComercialPipelineItem rendimiento_comerciales = 8;
   */
  rendimientoComerciales: ComercialPipelineItem[];
};

/**
 * Describes the message sextante.plataforma.ventas.v1.PipelineStatsResponse.
 * Use `create(PipelineStatsResponseSchema)` to create a new message.
 */
export const PipelineStatsResponseSchema: GenMessage<PipelineStatsResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 14);

/**
 * Cantidad de oportunidades en una etapa.
 *
 * @generated from message sextante.plataforma.ventas.v1.EmbudoPipelineItem
 */
export type EmbudoPipelineItem = Message<"sextante.plataforma.ventas.v1.EmbudoPipelineItem"> & {
  /**
   * @generated from field: string stage = 1;
   */
  stage: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: int32 count = 3;
   */
  count: number;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.EmbudoPipelineItem.
 * Use `create(EmbudoPipelineItemSchema)` to create a new message.
 */
export const EmbudoPipelineItemSchema: GenMessage<EmbudoPipelineItem> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 15);

/**
 * Cantidad de oportunidades por origen.
 *
 * @generated from message sextante.plataforma.ventas.v1.FuentePipelineItem
 */
export type FuentePipelineItem = Message<"sextante.plataforma.ventas.v1.FuentePipelineItem"> & {
  /**
   * @generated from field: string source = 1;
   */
  source: string;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.FuentePipelineItem.
 * Use `create(FuentePipelineItemSchema)` to create a new message.
 */
export const FuentePipelineItemSchema: GenMessage<FuentePipelineItem> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 16);

/**
 * Oportunidades y cierres de un comercial.
 *
 * @generated from message sextante.plataforma.ventas.v1.ComercialPipelineItem
 */
export type ComercialPipelineItem = Message<"sextante.plataforma.ventas.v1.ComercialPipelineItem"> & {
  /**
   * @generated from field: string comercial = 1;
   */
  comercial: string;

  /**
   * @generated from field: int32 leads = 2;
   */
  leads: number;

  /**
   * @generated from field: int32 cerrados = 3;
   */
  cerrados: number;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.ComercialPipelineItem.
 * Use `create(ComercialPipelineItemSchema)` to create a new message.
 */
export const ComercialPipelineItemSchema: GenMessage<ComercialPipelineItem> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 17);

/**
 * Ventana de la agenda.
 *
 * @generated from message sextante.plataforma.ventas.v1.PipelineAgendaRequest
 */
export type PipelineAgendaRequest = Message<"sextante.plataforma.ventas.v1.PipelineAgendaRequest"> & {
  /**
   * Unix ms
   *
   * @generated from field: int64 desde = 1;
   */
  desde: bigint;

  /**
   * Unix ms
   *
   * @generated from field: int64 hasta = 2;
   */
  hasta: bigint;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.PipelineAgendaRequest.
 * Use `create(PipelineAgendaRequestSchema)` to create a new message.
 */
export const PipelineAgendaRequestSchema: GenMessage<PipelineAgendaRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 18);

/**
 * Agenda del pipeline.
 *
 * @generated from message sextante.plataforma.ventas.v1.PipelineAgendaResponse
 */
export type PipelineAgendaResponse = Message<"sextante.plataforma.ventas.v1.PipelineAgendaResponse"> & {
  /**
   * Oportunidades en demo con contacto en la ventana.
   *
   * @generated from field: repeated sextante.plataforma.ventas.v1.OportunidadPipelineItem demos = 1;
   */
  demos: OportunidadPipelineItem[];

  /**
   * Otras oportunidades abiertas con contacto en la ventana.
   *
   * @generated from field: repeated sextante.plataforma.ventas.v1.OportunidadPipelineItem pendientes = 2;
   */
  pendientes: OportunidadPipelineItem[];

  /**
   * Oportunidades abiertas con el proximo contacto ya vencido.
   *
   * @generated from field: repeated sextante.plataforma.ventas.v1.OportunidadPipelineItem vencidos = 3;
   */
  vencidos: OportunidadPipelineItem[];
};

/**
 * Describes the message sextante.plataforma.ventas.v1.PipelineAgendaResponse.
 * Use `create(PipelineAgendaResponseSchema)` to create a new message.
 */
export const PipelineAgendaResponseSchema: GenMessage<PipelineAgendaResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 19);

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.ventas.v1.ListServiciosPipelineRequest
 */
export type ListServiciosPipelineRequest = Message<"sextante.plataforma.ventas.v1.ListServiciosPipelineRequest"> & {
};

/**
 * Describes the message sextante.plataforma.ventas.v1.ListServiciosPipelineRequest.
 * Use `create(ListServiciosPipelineRequestSchema)` to create a new message.
 */
export const ListServiciosPipelineRequestSchema: GenMessage<ListServiciosPipelineRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 20);

/**
 * Servicios cotizables.
 *
 * @generated from message sextante.plataforma.ventas.v1.ListServiciosPipelineResponse
 */
export type ListServiciosPipelineResponse = Message<"sextante.plataforma.ventas.v1.ListServiciosPipelineResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.ventas.v1.ServicioPipelineItem items = 1;
   */
  items: ServicioPipelineItem[];
};

/**
 * Describes the message sextante.plataforma.ventas.v1.ListServiciosPipelineResponse.
 * Use `create(ListServiciosPipelineResponseSchema)` to create a new message.
 */
export const ListServiciosPipelineResponseSchema: GenMessage<ListServiciosPipelineResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 21);

/**
 * Servicio cotizable, con los campos que pide la cotizacion.
 *
 * @generated from message sextante.plataforma.ventas.v1.ServicioPipelineItem
 */
export type ServicioPipelineItem = Message<"sextante.plataforma.ventas.v1.ServicioPipelineItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string descripcion = 3;
   */
  descripcion: string;

  /**
   * true si la cotizacion pide campos para este servicio.
   *
   * @generated from field: bool configurable = 4;
   */
  configurable: boolean;

  /**
   * @generated from field: repeated sextante.plataforma.ventas.v1.CampoServicioPipelineItem campos = 5;
   */
  campos: CampoServicioPipelineItem[];
};

/**
 * Describes the message sextante.plataforma.ventas.v1.ServicioPipelineItem.
 * Use `create(ServicioPipelineItemSchema)` to create a new message.
 */
export const ServicioPipelineItemSchema: GenMessage<ServicioPipelineItem> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 22);

/**
 * Campo que pide la cotizacion de un servicio.
 *
 * @generated from message sextante.plataforma.ventas.v1.CampoServicioPipelineItem
 */
export type CampoServicioPipelineItem = Message<"sextante.plataforma.ventas.v1.CampoServicioPipelineItem"> & {
  /**
   * @generated from field: string clave = 1;
   */
  clave: string;

  /**
   * @generated from field: string tipo = 2;
   */
  tipo: string;

  /**
   * @generated from field: optional int32 min = 3;
   */
  min?: number | undefined;

  /**
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * @generated from field: repeated string opciones = 5;
   */
  opciones: string[];

  /**
   * De donde salen las opciones del campo, si no vienen fijas.
   *
   * @generated from field: optional string fuente = 6;
   */
  fuente?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.ventas.v1.CampoServicioPipelineItem.
 * Use `create(CampoServicioPipelineItemSchema)` to create a new message.
 */
export const CampoServicioPipelineItemSchema: GenMessage<CampoServicioPipelineItem> = /*@__PURE__*/
  messageDesc(file_plataforma_ventas_pipeline, 23);

/**
 * Pipeline de ventas de la app Plataforma (menu Pipeline): oportunidades, etapas, eventos, demo, renovacion,
 * agenda, KPIs y catalogo de servicios cotizables. Migracion a gRPC-Web con logica propia (ver CLAUDE.md).
 * Las tarifas para cotizar salen de CostosPlataformaService. Solo los campos que usa la web. Requiere sesion
 * de Plataforma.
 *
 * @generated from service sextante.plataforma.ventas.v1.PipelinePlataformaService
 */
export const PipelinePlataformaService: GenService<{
  /**
   * Oportunidades no eliminadas con sus eventos, de la mas recientemente actualizada a la mas antigua.
   *
   * @generated from rpc sextante.plataforma.ventas.v1.PipelinePlataformaService.ListOportunidades
   */
  listOportunidades: {
    methodKind: "unary";
    input: typeof ListOportunidadesRequestSchema;
    output: typeof ListOportunidadesResponseSchema;
  },
  /**
   * Alta (nace en "new") o edicion.
   *
   * @generated from rpc sextante.plataforma.ventas.v1.PipelinePlataformaService.GuardarOportunidad
   */
  guardarOportunidad: {
    methodKind: "unary";
    input: typeof GuardarOportunidadRequestSchema;
    output: typeof OportunidadPipelineItemSchema;
  },
  /**
   * Cambia la etapa y registra el evento stage_change (+ nota opcional). closed_won activa el plan.
   *
   * @generated from rpc sextante.plataforma.ventas.v1.PipelinePlataformaService.CambiarEtapa
   */
  cambiarEtapa: {
    methodKind: "unary";
    input: typeof CambiarEtapaRequestSchema;
    output: typeof OportunidadPipelineItemSchema;
  },
  /**
   * Evento manual (note, llamada, visita, demo, cierre).
   *
   * @generated from rpc sextante.plataforma.ventas.v1.PipelinePlataformaService.AgregarEvento
   */
  agregarEvento: {
    methodKind: "unary";
    input: typeof AgregarEventoRequestSchema;
    output: typeof OportunidadPipelineItemSchema;
  },
  /**
   * Baja logica. Idempotente.
   *
   * @generated from rpc sextante.plataforma.ventas.v1.PipelinePlataformaService.EliminarOportunidad
   */
  eliminarOportunidad: {
    methodKind: "unary";
    input: typeof OportunidadIdRequestSchema;
    output: typeof PipelineAccionResponseSchema;
  },
  /**
   * Demo de 30 dias desde hoy.
   *
   * @generated from rpc sextante.plataforma.ventas.v1.PipelinePlataformaService.AsignarDemo
   */
  asignarDemo: {
    methodKind: "unary";
    input: typeof OportunidadIdRequestSchema;
    output: typeof OportunidadPipelineItemSchema;
  },
  /**
   * Suma dias al fin de la demo (o a hoy si no tenia).
   *
   * @generated from rpc sextante.plataforma.ventas.v1.PipelinePlataformaService.ExtenderDemo
   */
  extenderDemo: {
    methodKind: "unary";
    input: typeof ExtenderDemoRequestSchema;
    output: typeof OportunidadPipelineItemSchema;
  },
  /**
   * Reactiva el plan (closed_won) con una nueva fecha de renovacion.
   *
   * @generated from rpc sextante.plataforma.ventas.v1.PipelinePlataformaService.Renovar
   */
  renovar: {
    methodKind: "unary";
    input: typeof RenovarOportunidadRequestSchema;
    output: typeof OportunidadPipelineItemSchema;
  },
  /**
   * KPIs del tablero.
   *
   * @generated from rpc sextante.plataforma.ventas.v1.PipelinePlataformaService.GetStats
   */
  getStats: {
    methodKind: "unary";
    input: typeof PipelineStatsRequestSchema;
    output: typeof PipelineStatsResponseSchema;
  },
  /**
   * Oportunidades abiertas por proximo contacto en la ventana dada, y las vencidas.
   *
   * @generated from rpc sextante.plataforma.ventas.v1.PipelinePlataformaService.GetAgenda
   */
  getAgenda: {
    methodKind: "unary";
    input: typeof PipelineAgendaRequestSchema;
    output: typeof PipelineAgendaResponseSchema;
  },
  /**
   * Catalogo fijo de servicios cotizables.
   *
   * @generated from rpc sextante.plataforma.ventas.v1.PipelinePlataformaService.ListServicios
   */
  listServicios: {
    methodKind: "unary";
    input: typeof ListServiciosPipelineRequestSchema;
    output: typeof ListServiciosPipelineResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plataforma_ventas_pipeline, 0);

